module.exports = __webpack_public_path__ + "img/dcmm_13.82acd638.png";